import {ProjectCategory, ProjectStatus, Transaction} from '.'

export const PROJECT_CATEGORY_NAME: Record<ProjectCategory, string> = {
  construction: 'Construction',
  'buying-land': 'Buying land',
  'refinancing-existing-mortgage': 'Refinancing',
  bridging: 'Bridging',
  'land-subdivision': 'Land subdivision',
  'land-bank': 'Land banking',
}

export const PROJECT_STATUS_NAME: Record<ProjectStatus, string> = {
  pending: 'Pending',
  signed: 'Signed',
  opened: 'Live',
  closed: 'Closed',
  declined: 'Declined',
}

export const TRANSACTION_NAME: Record<Transaction, string> = {
  'initial-drawdown': 'Initial drawdown',
  drawdown: 'Drawdown',
  repayment: 'Repayment',
  'est-fee': 'Establishment fee',
  'application-fee': 'Application fee',
  fee: 'Line fee',
  interest: 'Interest',
  'broker-fee': 'Broker fee',
  'legal-fee': 'Legal fee',
  other: 'Other',
  'Journal Credit': 'Journal Credit',
  'Journal Debit': 'Journal Debit',
  'Journal Default Interest Credit': 'Journal Default Interest Credit',
  'other-fee': 'Other Fee',
  'default-interest': 'Default Interest',
}
